import React from "react";

const LightTheme = () => {
  return (
    <svg
      aria-hidden={true}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M7.99999 10.6667C9.47275 10.6667 10.6667 9.47277 10.6667 8.00001C10.6667 6.52725 9.47275 5.33334 7.99999 5.33334C6.52724 5.33334 5.33333 6.52725 5.33333 8.00001C5.33333 9.47277 6.52724 10.6667 7.99999 10.6667Z"
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 1.33334V2.66668"
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 13.3333V14.6667"
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.28667 3.28665L4.22667 4.22665"
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7733 11.7733L12.7133 12.7133"
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.33333 8H2.66666"
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3333 8H14.6667"
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.22667 11.7733L3.28667 12.7133"
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7133 3.28665L11.7733 4.22665"
          stroke="#666666"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath>
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LightTheme;
